import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function ReactQuillEditor(props) {
    let modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'image']
        ],
    };

    let formats = [
        'header',
        'bold', 'italic', 'underline',
        'list', 'bullet', 'indent',
        'link', 'image'
    ];

    return <ReactQuill theme="snow" modules={modules}
        formats={formats}
        value={props.value}
        onChange={props.onChange} />;
}